import styles from './ImpersonationBarInfo.module.scss';

type Props = {
    heading: string
    accountNumber: string
    accountName: string
}

export default function ImpersonationBarInfo({heading, accountNumber, accountName}: Props) {
	return (accountNumber) ? (
        <div className={styles.impersonationBarInfo}>
            <span className={styles.heading}>{heading}:</span>
            <span className={styles.separator}>|</span>
            <span className={styles.accountName}>{accountName}</span>
            <span className={styles.separator}>|</span> 
            <span className={styles.accountNumber}>Account # {accountNumber}</span>
        </div>
	) : 
        <div className={styles.currentInformation}>
            <span className={styles.noAccountSelected}>{heading}</span>
        </div>
    ;
}